import { Delete } from '@mui/icons-material';
import { FormHelperText, Grid, IconButton } from '@mui/material';
import TransactionTypeSelector from 'components/new/TransactionTypeSelector';

import { CurrencyCode } from 'further-types/lp/vehicle';
import NumberInput from 'further-ui/components/NumberInput';

type Props = {
  index: number;
  transactionErrors?: {
    message?: string;
    transactionTypeId?: { message?: string };
  };
  transaction: {
    reconcilableTransactionId?: string;
    transactionTypeId: string;
    debitAmountLcy: number;
    debitAmountTcy: number;
    creditAmountLcy: number;
    creditAmountTcy: number;
  };
  vehicleId: string;
  currency: CurrencyCode;
  onTransctionTypeChange: (index: number, value: string) => void;
  onDebitAmountChange: (index: number, value: number) => void;
  onCreditAmountChange: (index: number, value: number) => void;
  onRemove: (index: number) => void;
  disableRemove?: boolean;
};

const Transaction: React.FC<Props> = ({
  index,
  transaction,
  currency,
  vehicleId,
  transactionErrors,
  onTransctionTypeChange,
  onDebitAmountChange,
  onCreditAmountChange,
  onRemove,
  disableRemove,
}) => {
  return (
    <div>
      <Grid container spacing={2} alignItems="center">
        <Grid size="grow">
          <TransactionTypeSelector
            vehicleId={vehicleId}
            value={transaction.transactionTypeId}
            onChange={(value) => {
              onTransctionTypeChange(index, value);
            }}
            disabled={
              !!transaction.reconcilableTransactionId &&
              !!transaction.transactionTypeId
            }
          />
        </Grid>
        <Grid size={3}>
          <NumberInput
            fullWidth
            value={transaction.debitAmountLcy}
            onChange={(value) => {
              onDebitAmountChange(index, value ?? 0);
            }}
            currency={currency}
            decimals={2}
            placeholder="Enter debit amount"
            disabled={
              transaction.creditAmountLcy > 0 ||
              !!transaction.reconcilableTransactionId
            }
            error={!!transactionErrors}
          />
        </Grid>
        <Grid size={3}>
          <NumberInput
            fullWidth
            value={transaction.creditAmountLcy}
            onChange={(value) => {
              onCreditAmountChange(index, value ?? 0);
            }}
            currency={currency}
            decimals={2}
            placeholder="Enter credit amount"
            disabled={
              transaction.debitAmountLcy > 0 ||
              !!transaction.reconcilableTransactionId
            }
            error={!!transactionErrors}
          />
        </Grid>
        <Grid size={1}>
          {index > 1 && !disableRemove && (
            <IconButton
              size="small"
              onClick={() => {
                onRemove(index);
              }}
            >
              <Delete />
            </IconButton>
          )}
        </Grid>
      </Grid>
      {transactionErrors?.message ? (
        <FormHelperText error>{transactionErrors.message}</FormHelperText>
      ) : null}
    </div>
  );
};

export default Transaction;
